import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {Server} from '../classes/server';

@Injectable({
    providedIn: 'root'
})
export class ServerService {

    constructor(private apiService: ApiService) {
    }

    public getServers() {
        return this.apiService.getCallData$<Server[]>('servers');
    }
}
